import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Topbar from '../components/Topbar'
import Sidebar from '../components/Sidebar'
import styles from '../assets/css/Dashboard.module.css'
import { useAuth } from '../context/AuthContext'
import { 
  FaBuilding, 
  FaWater, 
  FaToilet, 
  FaTicketAlt, 
  FaHome,
  FaIdCard,
  FaCar,
  FaUserClock,
  FaHospital,
  FaRoad,
  FaDraftingCompass,
  FaPiggyBank
} from 'react-icons/fa'

function Dashboard() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  const department = JSON.parse(localStorage.getItem('department'));

  // useEffect(() => {
  //   const mainRole = localStorage.getItem('main_role');
  //   if (!isAuthenticated || mainRole !== 'mainchairman') {
  //     navigate('/');
  //   }
  // }, [isAuthenticated, navigate]);

  const menuItems = [
    { name: 'Bhavan', icon: <FaBuilding /> },
    { name: 'Water Tank', icon: <FaWater /> },
    { name: 'Sanitary', icon: <FaToilet /> },
    { name: 'Park Ticket', icon: <FaTicketAlt /> },
    { name: 'Property Tax', icon: <FaHome /> },
    { name: 'Licence', icon: <FaIdCard /> },
    { name: 'Car Report', icon: <FaCar /> },
    { name: 'Attendence', icon: <FaUserClock /> },
    { name: 'HFA', icon: <FaHospital /> },
    { name: 'PWD', icon: <FaRoad /> },
    { name: 'Building Plan', icon: <FaDraftingCompass /> },
    { name: 'Fund Management', icon: <FaPiggyBank /> }
  ]

  const handleCardClick = (itemName) => {
    navigate(`/${itemName.toLowerCase().replace(' ', '-')}`)
  }

  return (
    <>
      <Topbar/>
      <div className='d-flex'>
        <Sidebar/>
        <div className={styles.dashboardContainer}>
          <div className={styles.dashboardContent}>
            <div className={styles.cardGrid}>
              {menuItems.map((item, index) => (
                <div 
                  key={index} 
                  className={styles.card}
                  onClick={() => handleCardClick(item.name)}
                >
                  <div className={styles.iconWrapper}>
                    {item.icon}
                  </div>
                  <div className={styles.cardContent}>
                    <div className={styles.cardTitle}>{item.name}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard
